<template>
    <div>
       <div class="container-collab d-flex w-full h-full">
         <div class="col-md-3  w-full h-full">
           <filterdetailsmiscellaneous @search="search"></filterdetailsmiscellaneous>
         </div>
         <div class="col-md-9">
             <div class="table-detalhes">
               <Tables ref="tableGridLoteDiretoria"
                   :showBack="true"
                   :columns="['Lote','Funcionários','Função','Obra','Data Aprovação Coordenador','Data Aprovação Tranpostes','Início viagem','Fim viagem','Saldo','Total Gastos']"
                   :showReload="false"
                   v-on:Load="onLoad"
                   :showButtonNew="true"
                   :newHeaderStatus="true"
                   :showHeader="true"
                   >
                   <tr v-for="data in ArrayLotePagosDetalhes" :key="data.funcionarioId">
                       <TableColumn :IsText="true"   v-on:Edit="ModalPopup(data)" :status="data.demissaoData != null ? 0 : 1" :value="data.lote == null ? 'N/D': data.lote" />
                       <TableColumn :IsText="true"   v-on:Edit="ModalPopup(data)" :status="data.demissaoData != null ? 0 : 1" :value="data.funcionario == null ? 'N/D' : data.funcionario " />
                       <TableColumn :IsText="true"   v-on:Edit="ModalPopup(data)" :status="data.demissaoData != null ? 0 : 1" :value="data.cargo == null ? 'N/D' : data.cargo" />
                       <TableColumn :IsText="true"   v-on:Edit="ModalPopup(data)" :status="data.demissaoData != null ? 0 : 1" :value="data.obra == null ? 'N/D' : data.obra" />
                       <TableColumn :IsText="true"   v-on:Edit="ModalPopup(data)" :status="data.demissaoData != null ? 0 : 1" :value="formataData(data.dataCoordenador == null ? 'N/D' : data.dataCoordenador)" />
                       <TableColumn :IsText="true"   v-on:Edit="ModalPopup(data)" :status="data.demissaoData != null ? 0 : 1" :value="formataData(data.dataControladoria == null ? 'N/D' : data.dataControladoria)" />
                       <TableColumn :IsText="true"   v-on:Edit="ModalPopup(data)" :status="data.demissaoData != null ? 0 : 1" :value="formataData(data.dataInicial == null ? 'N/D' : data.dataInicial)" />
                       <TableColumn :IsText="true"   v-on:Edit="ModalPopup(data)" :status="data.demissaoData != null ? 0 : 1" :value="formataData(data.dataFinal == null ? 'N/D' : data.dataFinal)" />
                       <TableColumn :IsText="true"   v-on:Edit="ModalPopup(data)" :status="data.demissaoData != null ? 0 : 1" :value="formatMoney(data.saldo == null ? 'N/D' : data.saldo)" />
                       <TableColumn :IsText="true"   v-on:Edit="ModalPopup(data)" :status="data.demissaoData != null ? 0 : 1" :value="formatMoney(data.totalGasto == null ? 'N/D' : data.totalGasto)" />
                   </tr>
                   <template #return>
                      <button type="button" @click="back" class="btn btn-third btn-sm mr-2" ><i style="font-size:16px;padding-top:2px" class="fas fa-arrow-circle-left "></i></button>
                   </template>
                     <template #ButtonsAprova>
                         <div class="button-container">
                          <!-- <button @click="RepLoteBoard(loteid)" class="reprova"><i class="fas fa-thumbs-down mr-1" ></i>REPROVAR</button> -->
                          <button @click="openPopupReprove(loteid)" class="reprova"><i class="fas fa-thumbs-down mr-1" ></i>REPROVAR</button>
                          <button @click="apprLoteBoard(loteid)" class="button-apr"><i class="fas fa-thumbs-up ml-1" ></i>APROVAR</button>
                         </div>
                     </template>
               </Tables>
             </div>
         </div>
       </div>
         <b-modal
           centered hide-footer
           ref="popupExpenseDiretoria"
           :no-close-on-backdrop="true"
           size="xl"
           title="Despesas por Funcionário"
           >
           <h4 class="label mb-2"><strong>Lote: {{modalDetalhes.lote}}</strong></h4>
       <div class="date">
                     <div class="date-container">
                       <div class="date-content" style="width:25%">
                         <h5>Data Início:</h5>
                         <h6>{{modalDetalhes.dataInicialFormatado == null ? 'N/D' : modalDetalhes.dataInicialFormatado }}</h6>
                       </div>
                       <div class="date-content" style="width:75%">
                         <h5>Data Encerramento:</h5>
                         <h6>{{modalDetalhes.dataFinalFormatado == null ? 'N/D' : modalDetalhes.dataFinalFormatado}}</h6>
                       </div>
                     </div>
                 </div>
                 <Tables ref="tableGridLotePagoDetalhesModalDiversos"
                   :columns="['Categoria', 'Quantidade', 'Total Gasto','']"
                   :showReload="false"
                    v-on:Load="modalInfo()"
                   :showButtonNew="true"
                   :newHeaderStatus="true"
                   :showHeader="true"
                   >
                   <tr v-for="(data, index) in LotesEmployee" :key="index">
                       <TableColumn
                         :IsText="true"
                         :status="1"
                         :value="data.subCategoria ? data.subCategoria : 'N/D'"
                       />
                       <TableColumn
                         :IsText="true"
                         :status="1"
                         :value="data.quantidade == null ? 'N/D' : data.quantidade"
                       />
                       <TableColumn
                         :IsText="true"
                         :status="1"
                         :value="formatMoney(data.total)"
                         />
                       <TableColumn
                         :IsDocumentActions="true"
                         :HasDownload="false"
                         :HasDocumentDelete="false"
                         :status="1"
                       />
                     </tr>
               </Tables>
            <div class="total-container">
               <h4 class="label-total mb-2"><strong>Total: {{ formatMoney( modalDetalhes.total) }} </strong></h4>
            </div>
       </b-modal>
    <b-modal ref="modal-EscolhaReprova"
          size="md"
          centered
          id="add-brower-modal"
          title="Reprovação"
          :hide-footer="true"
          :no-close-on-backdrop="true"
          :no-close-on-esc="true"
      >
           <div class="icone-reprova">
              <i class="fas fa-thumbs-down"></i>
          </div>
          <div>
              <div class="labelmodal conteiner">Escolha o tipo de reprovação!</div>
          </div>
          <div class="conteiner pt-3">
              <button  @click="modalDevolucao" class="button-info">DEVOLUÇÃO</button>
              <button  @click="modalDefinitivo" class="button-reprova">DEFINITIVA</button>
          </div>
      </b-modal>
       <b-modal
            ref="devolver-despesa"
            size="md"
            centered
            id="add-brower-modal"
            title="Devolução da Lote"
            :hide-footer="true"
            :clickToClose="false"
            :no-close-on-backdrop="true"
            :no-close-on-esc="true"
            :hide-header-close="true"
        >
            <div>
                <!-- <div class="conteiner"><i class="fa fa-window-close icone"></i></div> -->
                <div class="label conteiner">Informe o motivo da devolução!</div>
                <div class="caxa-texto conteiner">
                    <textarea class="form-control mt-3" rows="10" cols="175" v-model="motivo"></textarea>
                </div>
            </div>
            <div class="conteiner pt-3">
                <button @click="backModal(loteid)" class="button-cancel">VOLTAR</button>
                <button @click="RepLoteBoard(loteid)" class="button-save">SALVAR</button>
            </div>
        </b-modal>
    </div>
   </template>

<script>
import tableboardpaiddirectory from './tableboardpaiddirectory'
export default tableboardpaiddirectory
</script>

<style scoped>
.container-collab{
  justify-content: space-between;
}
.head{
  margin-bottom: 1rem;
}
.details-body{
    height: 70vh;
    overflow: auto;
    background: white;
    border: 1px solid rgb(145, 145, 145) ;
}
.button-container{
  display: flex;
  align-items: center;
  justify-content: center;
  width:100%;
  gap: 1rem;
}

.date{
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: flex-start;
}
.date-container{
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.details-modal{
  padding:1.2rem;
}
.label-total{
  padding: 0 1.2rem 0 1.2rem;
}
.total-container{
  display: flex;
  width: 100%;
  height: 100%;
  align-content: center;
  justify-content: flex-end;
}
.button-apr{
    height: 2rem;
    background: #008144;
    width: 150px;
    color: white;
    border: none;
    border-radius: 10px;
}
.button-apr:hover{
    background: #016436;
}
.reprova{
    height: 2rem;
    background: red;
    width: 150px;
    color: white;
    border: none;
    border-radius: 10px;
}
.reprova:hover{
    background: rgb(214, 1, 1);
}

.icone-reprova{
    display: flex;
    font-size: 44px;
    padding: 10px;
    justify-content: center;
}
.labelmodal{
    padding: 1rem;
    font: normal normal 600 15px/20px Segoe UI;
    font-size: 20px;
    font-weight: bold;
}
.conteiner{
    display: flex;
    gap: 4rem;
    justify-content: center;
}
.button-info{
    border-radius: 8px;
    border: transparent;
    height: 2.5rem;
    width: 8rem;
    color: white;
    background-color: rgb(208 195 43);
}
.button-reprova{
    border-radius: 8px;
    border: transparent;
    height: 2.5rem;
    width: 8rem;
    color: white;
    background-color: rgb(168 28 6);
}

.button-cancel{
    border-radius: 8px;
    border: transparent;
    height: 2.5rem;
    width: 8rem;
    color: white;
    background-color: rgb(167, 30, 30);
}
.button-save {
    border-radius: 8px;
    border: transparent;
    height: 2.5rem;
    width: 8rem;
    color: white;
    background-color: rgb(4, 90, 30);
}
</style>



// WEBPACK FOOTER //
// src/views/private/miscellaneousreimbursement/components/tableboard/components/tableboardpaiddirectory.vue